import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogDescription,
} from "@lab/src/components/ui/dialog";
import { Button } from "@lab/src/components/ui/button";
import { TariffWithPricesViewType } from "@/dentlab/src/store/Catalogs";
import { ExtendedArticleEntityType } from "@/dentlab/src/store/Jobs/types";

interface TariffSelectionDialogProps {
	open: boolean;
	items: (TariffWithPricesViewType | ExtendedArticleEntityType)[];
	code: string;
	onSelect: (item: TariffWithPricesViewType | ExtendedArticleEntityType) => void;
	onCancel: () => void;
}

export const TariffSelectionDialog: React.FC<TariffSelectionDialogProps> = ({
	open,
	items,
	code,
	onSelect,
	onCancel,
}) => {
	const isTariff = (item: TariffWithPricesViewType | ExtendedArticleEntityType): item is TariffWithPricesViewType => {
		return "price_items" in item;
	};

	const getItemDescription = (item: TariffWithPricesViewType | ExtendedArticleEntityType): string => {
		return item.description_de || item.description_fr || item.description_it || "";
	};

	const getItemPrice = (item: TariffWithPricesViewType | ExtendedArticleEntityType): string => {
		if (isTariff(item)) {
			if (!item.price_items || item.price_items.length === 0) {
				return "N/A";
			}
			const prices = item.price_items.filter(item => item.price && item.price_list_name).map(item => item.price_list_name + ": " + item.price?.toFixed(2));
			return prices.join(", ");
		}
		return item.price ? `CHF ${item.price.toFixed(2)}` : "N/A";
	};

	const handleSelect = (item: TariffWithPricesViewType | ExtendedArticleEntityType) => {
		onSelect(item);
	};

	return (
		<Dialog open={open} onOpenChange={(open) => !open && onCancel()}>
			<DialogContent className="max-w-2xl">
				<DialogHeader>
					<DialogTitle>Position auswählen</DialogTitle>
					<DialogDescription>
						{items.length} Positionen mit Code "{code}" gefunden. Bitte wählen Sie eine aus. (Um eine eindeutige Position für diesen Tarif einzustellen, navigieren Sie zu "Mein Labor - Tarifkataloge")
					</DialogDescription>
				</DialogHeader>
				<div className="max-h-96 overflow-y-auto space-y-2">
					{items.map((item) => (
						<button
							type="button"
							key={item.id}
							onClick={(e) => {
								e.preventDefault();
								e.stopPropagation();
								handleSelect(item);
							}}
							className="w-full text-left p-4 border rounded-md hover:bg-gray-50 transition-colors border-gray-200"
							data-testid={`tariff-selection-item-${item.id}`}
							aria-label={`Position ${item.code_e} auswählen`}
						>
							<div className="font-semibold">{item.code_e}</div>
							<div className="text-sm text-gray-600 mt-1">
								{getItemDescription(item)}
							</div>
							<div className="text-sm text-gray-500 mt-1">
								Preis: {getItemPrice(item)}
							</div>
						</button>
					))}
				</div>
			</DialogContent>
		</Dialog>
	);
};
